const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');

const StarterPackList = () => import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/view/index.vue');
const StarterPackAdd = () => import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/view/add.vue');
const StarterPackEdit = () => import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/view/edit.vue');
const StarterPackDetail = () => import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/view/detail.vue');

const StarterPackRewardList = () =>
    import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/reward/view/index.vue');
const StarterPackRewardAdd = () =>
    import(/* webpackChunkName: "starter" */ '@/modules/starter/pack/reward/view/add.vue');

export const ROUTE_NAME_STARTER = {
    PACK: {
        INDEX: 'StarterPackList',
        ADD: 'StarterPackAdd',
        EDIT: 'StarterPackEdit',
        DETAIL: 'StarterPackDetail',
        REWARD: {
            INDEX: 'StarterPackRewardList',
            ADD: 'StarterPackRewardAdd'
        }
    }
} as const;

export default [
    {
        path: '/app/:appId/starter/pack',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'StarterPackList',
                component: StarterPackList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: 'StarterPackAdd',
                component: StarterPackAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/edit',
                name: 'StarterPackEdit',
                component: StarterPackEdit,
                meta: { requiresAuth: true }
            },
            {
                path: ':id/detail',
                name: 'StarterPackDetail',
                component: StarterPackDetail,
                meta: { requiresAuth: true }
            },
            {
                path: ':starterPackId/reward/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: 'StarterPackRewardList',
                        component: StarterPackRewardList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: 'StarterPackRewardAdd',
                        component: StarterPackRewardAdd,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
